import { motion } from 'framer-motion';
import { cardHover, ease } from '../../motion/variants';

const AnimatedCard = ({
  children,
  className = '',
  hover = true,
  as: Tag = motion.article,
  ...props
}) => (
  <Tag
    initial="rest"
    whileHover={hover ? 'hover' : undefined}
    variants={cardHover}
    transition={{ duration: 0.35, ease }}
    className={`ant-card ant-ring ant-card-hover ${className}`}
    {...props}
  >
    {children}
  </Tag>
);

export default AnimatedCard;